import { render, staticRenderFns } from "./Mesajlar.vue?vue&type=template&id=5bf54820&"
import script from "./Mesajlar.vue?vue&type=script&lang=js&"
export * from "./Mesajlar.vue?vue&type=script&lang=js&"
import style0 from "./Mesajlar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports